export const MOBILE_EVENT_CLOSE = 'close';
export const MOBILE_EVENT_LOGIN = 'login';
export const MOBILE_EVENT_PAGE_LOADED = 'pageLoaded';
export const MOBILE_CAMERA_PERMISSIONS_REQUEST = 'cameraPermissions';
export const MOBILE_GA_EVENT = 'gaEvent';
export const MOBILE_GA_EVENT_V2 = 'gaEventV2';

export interface Me {
  id: string;
  person: {
    email: string;
    exclude_from_analytics: boolean;
    first_name: string;
    id: string;
    last_name: string;
    nickname: string;
    phone: string;
    profile_image_url: string;
    pronouns: string;
    time_zone?: string;
  };
}

export interface UserAppointmentFull {
  agent: Agent;
  appointment: AppointmentFull;
  attended: boolean;
  auto_cancelled_at: string | null;
  auto_cancel_eligible: boolean;
  cancelled: boolean;
  cancelled_by_member_at: string | null;
  drug_screen?: {
    assignment_type?: string;
    bac_value?: string;
    drug_category?: string;
    id: string;
    kind?: string;
    occurred_at: string;
    substance?: string;
  };
  expected_bonus: number;
  id: string;
  payout: IPayout;
  payout_details: IPayoutDetails;
  state: Status;
}

export interface IPayoutInCents {
  base_in_cents: number;
  bonus_in_cents: number;
  test_administration_in_cents: number;
  attendance_in_cents: number;
  total_in_cents: number;
}

export interface IPayoutDetails {
  usd: IPayoutInCents;
  exp: IPayoutInCents;
}

export interface IPayout {
  base: string;
  bonus: string;
  test_administration: string;
  attendance: string;
}

export enum Status {
  ATTENDED = 'attended',
  CANCELLED = 'cancelled',
  CONFIRMED = 'confirmed',
  NOT_SCHEDULED = 'not_scheduled',
  NO_SHOW = 'no_show',
  PENDING = 'pending',
  PENDING_ATTENDANCE = 'pending_attendance',
  RESCHEDULED = 'rescheduled'
}

export interface AppointmentFull {
  actual_duration: number;
  appointment_type: AppointmentType;
  description: string;
  duration_in_seconds: number;
  end_at: string;
  id: string;
  meeting_status: string;
  rich_description: string;
  start_at: string;
  title: string;
  zoom_join_url: string;
}

export interface AppointmentType {
  id: string;
  auto_cancel: boolean;
  name: string;
  is_active: boolean;
  drug_screen_expected: boolean | null;
  group_meeting: boolean;
  is_intake: boolean;
  can_be_rescheduled_by_member: boolean;
}

export interface Agent {
  email: string;
  first_name: string;
  last_name: string;
}

export interface UserAppointmentFull {
  agent: Agent;
  appointment: AppointmentFull;
  attended: boolean;
  auto_cancelled_at: string | null;
  auto_cancel_eligible: boolean;
  cancelled: boolean;
  cancelled_by_member_at: string | null;
  drug_screen?: {
    assignment_type?: string;
    bac_value?: string;
    drug_category?: string;
    id: string;
    kind?: string;
    occurred_at: string;
    substance?: string;
  };
  expected_bonus: number;
  id: string;
  payout: IPayout;
  payout_details: IPayoutDetails;
  state: Status;
}

export interface IPayoutInCents {
  base_in_cents: number;
  bonus_in_cents: number;
  test_administration_in_cents: number;
  attendance_in_cents: number;
  total_in_cents: number;
}

export interface IPayoutDetails {
  usd: IPayoutInCents;
  exp: IPayoutInCents;
}

export interface IPayout {
  base: string;
  bonus: string;
  test_administration: string;
  attendance: string;
}

export interface AppointmentFull {
  actual_duration: number;
  appointment_type: AppointmentType;
  description: string;
  duration_in_seconds: number;
  end_at: string;
  id: string;
  meeting_status: string;
  rich_description: string;
  start_at: string;
  title: string;
  zoom_join_url: string;
}

export interface AppointmentType {
  id: string;
  auto_cancel: boolean;
  name: string;
  is_active: boolean;
  drug_screen_expected: boolean | null;
  group_meeting: boolean;
  is_intake: boolean;
  can_be_rescheduled_by_member: boolean;
}

export interface Agent {
  email: string;
  first_name: string;
  last_name: string;
}

export enum ZoomRole {
  ATTENDEE = '0',
  HOST = '1'
}
